import React, { createContext, useContext, useEffect, useState } from "react";
import { useAppConfig } from "./AppConfigurationsContext";

// The value in NLS and PROSPECT will be used fot the Type in the links list page filter.
export const allowedGroups = {
  NLS: { value: "NLS", displayName: "COMMLINK LOGIN" },
  PROSPECT: { value: "PROSPECT", displayName: "PROSPECT" },
};

const AuthorizationContext = createContext();

export const useAuthorization = () => {
  return useContext(AuthorizationContext);
};

const AuthorizationProvider = ({ instance, children }) => {
  const { appConfig } = useAppConfig();

  // allowedGroupsCodes will have the real Entra security groups names
  // The application uses its own names for the roles, the "translation" between
  // the app names and Entra names happens here.
  const allowedGroupsCodes = {
    NLS: { value: appConfig.REACT_APP_NLS_SECURITY_GROUP_NAME },
    PROSPECT: { value: appConfig.REACT_APP_PROSPECT_SECURITY_GROUP_NAME },
  };

  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const changeGroup = (group) => {
    setSelectedGroup(group);
  };

  useEffect(() => {
    const activeInstance = instance.getActiveAccount();
    const activeRoles = activeInstance.idTokenClaims.roles || [];

    if (activeRoles.length === 0) return;

    var tempGroups = [];

    if (activeRoles.find((x) => x === allowedGroupsCodes.NLS.value))
      tempGroups.push(allowedGroups.NLS);
    if (activeRoles.find((x) => x === allowedGroupsCodes.PROSPECT.value))
      tempGroups.push(allowedGroups.PROSPECT);

    setGroups(tempGroups);
    setSelectedGroup(tempGroups[0].value);
  }, [instance]);

  return (
    <AuthorizationContext.Provider
      value={{ allowedGroupsCodes, groups, selectedGroup, changeGroup }}
    >
      {children}
    </AuthorizationContext.Provider>
  );
};

export default AuthorizationProvider;
